import { httpBus } from "@/api/index.js";


/**
 * 查询抄表详情
 * @param {*} params 
 * @returns 
 */
export function getPeriodPrice(params) {
  return httpBus.request("get", "/dashboard/income/settlement/query", {
    params
  });
}

/**
 * 获取数据
 * @param {*} params 
 * @returns 
 */
export function getIncomeData(params) {
  return httpBus.request("get", "/dashboard/income/settlement/v2/data/query", {
    params
  });
};

/**
 * 结算模板--更新
 * @param {*} params 
 * @returns 
 */
export function getIncomeSettlement(params) {
  return httpBus.request("put", "/dashboard/income/settlement/v2/info/update",  { data: 
    params
  });
};

/**
 * 结算模板--查询
 * @param {*} params 
 * @returns 
 */
export function getIncomeQuery(params) {
  return httpBus.request("get", "/dashboard/income/settlement/v2/info/query", {
    params
  });
};

/**
 * 结算模板--删除
 * @param {*} id 
 * @returns 
 */
export function deleteInfo(id) {
  return httpBus.request("delete", `/dashboard/income/settlement/v2/info/delete?stationId=${id}`);
};



